'use client'

import {
  Box,
  Flex,
  HStack,
  Menu,
  MenuButton,
  useColorModeValue,
  Image
} from '@chakra-ui/react'
import logo from './Blockchain-UCSB.png'
import { Link as ScrollLink } from 'react-scroll';



const Links = ['Speakers', 'Agenda', 'Happy Hour']
//

// export default function Navbar() {
//   return (
//     <Flex>
//       <Link to="/sponsors" style={{ zIndex: 10 }}>Sponsors</Link>
//       <Link to="/agenda" style={{ zIndex: 10 }}>Agenda</Link>
//       <a href="https://forms.gle/sLiEcrU5t1abLR1B8" style={{ zIndex: 10 }}>Register</a>
//     </Flex>
//   );
// };
const NavLink = (props) => {
  const { children, onClick } = props;

  return (
    <Box
      as="a"
      px={2}
      py={1}
      rounded={'md'}
      _hover={{
        textDecoration: 'none',
        bg: useColorModeValue('gray.200', 'gray.700'),
      }}
      cursor={'pointer'}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
export default function Navbar() {


  return (
    <>
      <Box bg={useColorModeValue('gray.100', 'gray.900')} px={4}>
      <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
        <HStack spacing={8} alignItems={'center'}>
          <Image src={logo} alt="Logo" width="auto" height="30px" />
          <HStack
            as={'nav'}
            spacing={4}
            display={{ base: 'none', md: 'flex' }}
            alignItems="center"
            justify="center"
          >
            {Links.map((link) => (
              <ScrollLink key={link} to={link.toLowerCase()} smooth={true} duration={500}  style={{ zIndex: 1 }}>
                <NavLink>{link}</NavLink>
              </ScrollLink>
            ))}
          </HStack>
        </HStack>

          <Flex alignItems={'center'}>
            <Menu>
              <MenuButton
                as="a"  // Render as an anchor element
                href="https://forms.gle/sLiEcrU5t1abLR1B8"  // Specify the URL you want to navigate to
                rounded={'full'}
                variant={'link'}
                cursor={'pointer'}
                minW={0}
                style={{ zIndex: 1 }} // Add this line
                >
                Register
              </MenuButton>
            </Menu>
          </Flex>

        </Flex>

    
      </Box>

    </>
  )
}